export default __webpack_public_path__ + "static/media/FilterBubbleMockup.d903912f.png";